import axios from 'axios';

const BASE_URL = 'https://aprendeticbackend-dev-xegb.3.us-1.fl0.io/api/';
//const BASE_URL = 'http://localhost:4000/api/';

export default axios.create({
    baseURL: BASE_URL
})

export const axiosPrivate = axios.create({
    baseURL: BASE_URL,
})

